// The order of the Dock's places and the ones left out, kept on this device
// (the phone's settings). Here, apart from the phone's kit, because the
// outside's menu also hands it to a host that draws the Dock (a native app).
import { defineDeviceSetting } from "../device/device-setting";

export interface DockPrefs {
  order: readonly string[];
  hidden: readonly string[];
}

const strings = (v: unknown): string[] =>
  Array.isArray(v) ? v.filter((x): x is string => typeof x === "string") : [];

export function parseDockPrefs(raw: string | null): DockPrefs {
  try {
    const v = JSON.parse(raw ?? "null") as Partial<DockPrefs> | null;
    return { order: strings(v?.order), hidden: strings(v?.hidden) };
  } catch {
    return { order: [], hidden: [] };
  }
}

/** The Dock's order and hidden entries on this device. */
export const dockPrefsSetting = defineDeviceSetting<DockPrefs>({
  key: "trameria-phone-dock",
  parse: parseDockPrefs,
  serialize: (v) => JSON.stringify(v),
});
